import { apiClient } from './client';

/**
 * Placeholder — full payment surface (approve/reject deposit/withdrawal, manual ops)
 * lives in Fase 3. See ARCHITECTURE.md §2.4 + KNOWLEDGE.md §7.
 */
export const paymentsApi = {
  list: async (
    params: { kind?: 'deposit' | 'withdrawal'; type?: 'deposit' | 'withdrawal'; status?: string; clientId?: string } = {},
  ) => {
    // el backend espera `kind` (no `type`); mantenemos `type` por compat con retiros.tsx
    const { type, ...rest } = params;
    const query = { ...rest, ...(type ? { kind: type } : {}) };
    const { data } = await apiClient.get('/admin/payments', { params: query });
    return data;
  },

  approve: async (id: string) => {
    const { data } = await apiClient.post(`/admin/payments/${id}/approve`);
    return data;
  },

  reject: async (id: string, reason: string) => {
    const { data } = await apiClient.post(`/admin/payments/${id}/reject`, { reason });
    return data;
  },
};
